/**
 * Auto generated file, do not edit.
 */

export const appVersion: string = '0.0.0';
